(function() {

	var QuoteRequestPage = function(uploadURL) {
		this.uploadURL = uploadURL;
		//this.uploadURL = "http://localhost:3000/mattg/api/temporary_uploads";
		this.uploadingAttachment = false;
		this.initItems();
		this.initAttachments();
		C.initDatePickers();
	};

	QuoteRequestPage.prototype = {
		initItems: function() {
			var self = this;

			// Handle item adds
			$('#add_item').on('click', function() {
				self.addItem();
			});

			// Handle item deletes
			$(document).delegate('#quote_request_items .remove-item', 'click', function(e) {
				self.removeItem(this);
			});

			this.validator = new C.FormValidator('form.quote-request-form');

			$('form.quote-request-form').on('submit', function(event) {
				if(!self.validator.isValid()) {
					alert("One or more errors need to be corrected before the request can be submitted.");
					event.preventDefault();
				} else if (self.uploadingAttachment) {
					alert("One or more attachments need to finish uploading before the request can be submitted.")
					event.preventDefault();
				} else {
					$('form.quote-request-form :submit').prop('disabled', true)
				}
			});
		},
		
		initAttachments: function() {
			var self = this;
			$(".quote-request-attachments").dropzone({
				url: this.uploadURL,
				maxFiles: 10,
				timeout: 1000 * 60, // 1 minute
				maxFilesize: 100, //100 MB
				addRemoveLinks: true,
				init: function() {
					this.on('sending', function(file, xhr, formData){
						formData.append('upload_uuid', file.upload.uuid)
						self.uploadingAttachment = true
					});
					this.on('queuecomplete', function(file){ self.uploadingAttachment = false; });
					this.on('success', function(file, res){
						var empty_attachment_inputs = $('.quote-attachment-id').filter(function() {return this.value == '' });
						if (empty_attachment_inputs.length) {
							var input = empty_attachment_inputs.first();
							input.val(res.upload_id);
							input.data('upload-uuid', file.upload.uuid);
						}
					});
					this.on('removedfile', function(file, res) {
						var input = $('.quote-attachment-id').filter(function () { 
							return $(this).data('upload-uuid') == file.upload.uuid
						}).first();
						input.val(null);
						input.data('upload-uuid', null);
						
						// Send request to delete from s3
						$.ajax({
							url: self.uploadURL + "/" + file.upload.uuid,
							method: 'delete'
						})
					});
				}
			});
		},

		addItem: function() {
			var tbody = $('#quote_request_items tbody');
			var rows = tbody.find('tr');
			var id = rows.length;

			var template = $(rows[0]).html();
			template = template.replace(new RegExp('\\[0\\]', 'g'), '[' + id + ']');
			template = template.replace(new RegExp('_0_', 'g'), '_' + id + '_');
			tbody.append('<tr>' + template + '</tr>');
			tbody.children('tr').last().find('input, select').each(function(i, elem) {
				$(elem).val('');
			});
			C.initDatePickers();
		},

		removeItem: function(elem) {
			var tbody = $('#quote_request_items tbody');
			var rows = tbody.find('tr');
			if (rows.length == 1) {
				alert("Quote requests must contain at least one item");
				return;
			}

			// Delete the row
			var row = $(elem).closest('tr');
			row.remove();
		}

	};

	C.QuoteRequestPage = QuoteRequestPage;

})();
